<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <div id="digram-result" class="parallax digramresult">
      <div class="digramresultlp" v-if="digramResult">
        <!--概要-->
        <section class="renew2_wrapper about">
          <div class="about__title">
            <p class="bluetxt title_sub">ヤギディ診断であなたは…</p>
            <!-- <p class="catch_txt">どの草が一番効率いいか考えてから<br>食べる戦略系</p> -->
            <p class="catch_txt" v-html="digramResult.catch_copy"></p>
            <!-- <h3 class="bluetxt title">やり手ヤギ</h3> -->
            <h3 class="bluetxt title">{{ digramResult.catch_copy_title }}</h3>
          </div>
          <div class="about__contents">
            <img :src="`/static/img/digram/${result}/01.png`" alt="ヤギタイプ" class="about_img">
            <!-- <p class="about_lead">
              自信と行動力、そして論理的思考を兼ね備えた、まさにリーダーの素質を持つタイプです。状況判断が早く、戦略的に物事を進める計画性を持ち、チームの中で自然とリーダー的な役割を担います。困難な状況にも粘り強く立ち向かい、成果を追い求める姿勢が強く、結果にコミットできる信頼性があります。常に成長意識を持ち、目標に向けて着実に前進するエネルギーがあり、組織内での存在感も抜群です。
            </p> -->
            <p class="about_lead">
              {{ digramResult.base }}
            </p>
          </div>
        </section>

        <!--強み弱み職種-->
        <section class="renew2_wrapper digramcontents">
          <div class="digramcontents__type">
            <!--強み-->
            <div>
              <h4 class="hukidashi yagitxt bluetxt typeh4">あなたの強みメェ〜</h4>
              <!--<img src="" alt="あなたの強み" class="typeimg">-->
              <!-- <p class="hukidashi yagitxt">
                高い判断力と決断力により、物事を迅速かつ的確に進められます。目標達成に向けて全体を見渡し、チームを動かす指揮力があります。論理的でプレゼン力もあり、説得力をもって周囲を巻き込む力があるのも特徴です。面接では、リーダー経験や困難を打開した実績など、数値や結果を交えて語るとより好印象です。
              </p> -->
              <p class="hukidashi yagitxt">
                {{ digramResult.strength }}
              </p>
              <div class="usertxt-right">
                <p class="hukidashi usertxt">ほんとかな〜</p>
              </div>
            </div>

            <!--弱み-->
            <div>
              <h4 class="hukidashi yagitxt bluetxt typeh4">あなたの弱みメェ〜</h4>
              <!--<img src="" alt="あなたの弱み" class="typeimg">-->
              <!-- <p class="hukidashi yagitxt">
                自信が強すぎると柔軟性を欠き、周囲の意見に耳を傾けにくくなる傾向があります。成果を急ぐあまり慎重さを失い、細部への配慮が抜けることも。面接では、協働における気づきや、他人の意見を受け入れて改善したエピソードを伝えることで、リーダーとしての人間力と成長意欲を感じてもらうことができます。
              </p> -->
              <p class="hukidashi yagitxt">
                {{ digramResult.weakness }}
              </p>
              <div class="usertxt-right">
                <p class="hukidashi usertxt">それで向いてる職種は？</p>
              </div>
            </div>
          </div>

          <div class="digramcontents__job">
            <h4 class="bluetxt typeh4">強みと弱みから、<br>あなたが活躍できる職種</h4>
            <!-- <h5 class="jobh5">営業マネージャー<br>経営企画・事業開発<br>スタートアップ経営者（起業家）</h5> -->
            <h5 class="jobh5">{{ digramResult.rec_jobs }}</h5>
            <img :src="`/static/img/digram/${result}/02.png`" alt="あなたが活躍できる職種" class="typeimg">
            <!-- <p class="job_txt">論理性・実行力・決断力を武器に、あらゆる分野で活躍できます。</p> -->
            <p class="job_txt">{{ digramResult.explanation }}</p>
          </div>

          <div class="cv-block" v-if="$firebase.isAuthenticated">
            <a href="/format/shokumukeirekisho/edit/pr-message" class="cv-block__btn">結果を元に自己PRを書き直す</a>
            <a href="/yagiprimeinfo" class="cv-block__btn">エージェントに希望を伝える</a>
          </div>
          <div class="cv-block" v-else>
            <a href="/format/shokumukeirekisho/edit/pr-message" class="cv-block__btn">結果を元に自己PRを書く</a>
          </div>
        </section>

        <!--アイテム-->
        <section class="renew2_wrapper advice">
          <div class="usertxt-right">
            <p class="hukidashi usertxt">ほかにも教えて！</p>
          </div>

          <h4 class="hukidashi yagitxt bluetxt typeh4">あなたに送る<br>ヤギ格言あるメェ</h4>
          <img :src="`/static/img/digram/${result}/saying.png`" alt="アイテム" class="typeimg">
          <!-- <p class="hukidashi yagitxt">全体を俯瞰して流れを変える力を持つ。（風を読む）</p> -->
          <p class="hukidashi yagitxt">{{ digramResult.proverb }}</p>

          <div class="usertxt-right">
            <p class="hukidashi usertxt">まだあるの？</p>
          </div>

          <h4 class="hukidashi yagitxt bluetxt typeh4">あなたにぴったりの<br>アイテムも用意したメェ</h4>
          <img :src="`/static/img/digram/${result}/item.png`" alt="アイテム" class="typeimg">
          <!-- <p class="hukidashi yagitxt">結果を出すために、今日も笛を吹く。</p> -->
          <p class="hukidashi yagitxt">{{ digramResult.item }}</p>

          <div class="cv-block">
            <a href="/format/shokumukeirekisho/edit/pr-message" class="cv-block__btn" v-if="$firebase.isAuthenticated">結果を元に自己PRを書き直す</a>
            <a href="/format/shokumukeirekisho/edit/pr-message" class="cv-block__btn" v-else>結果を元に自己PRを書く</a>
            <!--<a href="" class="cv-block__btn cv-block__btn--list">一覧を見る</a>-->
          </div>
        </section>

        <!--シェア-->
        <section class="renew2_wrapper share">
          <h4 class="bluetxt typeh4">ヤギディをシェアする</h4>
          <div class="flex share__btnlist">
            <a :href="`http://www.facebook.com/sharer/sharer.php?u=${URL}`" rel="nofollow noopener" target="_blank"
              class="btnitem"><span class="btn_circle btn_circle--facebook">F</span>Facebook</a>
            <a :href="`http://line.me/R/msg/text/?${URL}%0a{ヤギッシュ｜ディグラム診断結果}`" target="_blank" rel="nofollow noopener"
              class="btnitem"><span class="btn_circle btn_circle--line">L</span>LINE</a>
            <!--<a href="https://twitter.com/share?ref_src=twsrc%5Etfw" class="twitter-share-button" data-show-count="false">Tweet</a>-->
            <a :href="`http://b.hatena.ne.jp/add?mode=confirm&url=${URL}&title={ヤギッシュ｜ディグラム診断結果}`"
              rel="nofollow noopener" target="_blank" class="btnitem"><span
                class="btn_circle btn_circle--hatena">H</span>はてなブログ</a>
            <a :href="`http://getpocket.com/edit?url=${URL}&title={ヤギッシュ｜ディグラム診断結果}`" rel="nofollow noopener"
              target="_blank" class="btnitem"><span class="btn_circle btn_circle--pocket">P</span>pocket</a>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../../assets/scss/variables.scss";

.parallax {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  clip-path: inset(0);

  &::after {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    z-index: -10;
    width: 100%;
    height: 100%;
    background-image: url(/static/img/digram/result_back.png);
    background-size: cover;
    background-position: center;
    opacity: 0.6;
  }
}

.digramresult {

  a:hover {
    opacity: 1;
    text-decoration: none;
  }

  .digramresultlp {
    width: 360px;
    margin: 0 auto;
    padding-bottom: 50px;
    background: #FFFFE8;

    @include max-width(sm) {
      width: 100%;
    }

    .about {
      &__title {
        margin-bottom: 20px;

        .title_sub {
          text-align: center;
          margin-bottom: 20px;
        }

        .catch_txt {
          font-weight: bold;
          font-size: 18px;
          color: #E95B10;
        }

        .title {
          font-size: 24px;
        }
      }

      &__contents {
        .about_img {
          margin-bottom: 20px;
          border-radius: 10px;
        }

        .about_lead {
          color: #0E536D;
        }
      }
    }

    .digramcontents {
      &__job {
        background: #ffffff;
        border: 1px solid #dfdfdf;
        border-radius: 10px;
        padding: 20px;
        margin-bottom: 20px;

        .typeh4 {
          display: block;
          text-align: center;
          line-height: 1.4;
          margin-bottom: 20px;
        }

        .jobh5 {
          position: relative;
          font-weight: bold;
          font-size: 24px;
          color: #E95B10;
          text-align: center;
          margin-bottom: 20px;

          //&::after{
          //    position: absolute;
          //    content: "";
          //    width: 100px;
          //    height: 5px;
          //    background: #E95B10;
          //    bottom: 0;
          //    right: calc(50% - 50px);
          //}
        }

        .job_txt {
          color: #0E536D;
        }
      }
    }

    .advice {
      margin-bottom: 10px;
    }

    .share {
      border-top: 1px solid #dfdfdf;
      border-bottom: 1px solid #dfdfdf;

      .typeh4 {
        display: block;
        text-align: center;
        margin-bottom: 20px;
      }

      &__btnlist {
        justify-content: space-around;

        .btnitem {
          text-align: center;
          font-size: 10px;

          .btn_circle {
            position: relative;
            display: flex;
            justify-content: center;
            width: 0;
            height: 0;
            border-style: solid;
            border-right: 20px solid transparent;
            border-left: 20px solid transparent;
            border-bottom: 35px solid #1877f2;
            border-top: 0;
            text-align: center;
            line-height: 40px;
            color: #ffffff;
            font-weight: bold;
            font-size: 14px;
            margin: 0 auto;

            &::before {
              position: absolute;
              content: "";
              border-right: 20px solid transparent;
              border-bottom: 35px solid #1877f2;
              height: 0;
              width: 0;
              left: -20px;
            }

            &::after {
              position: absolute;
              content: "";
              border-left: 20px solid transparent;
              border-bottom: 35px solid #1877f2;
              height: 0;
              width: 0;
              left: 0;
            }

            &--line {
              border-bottom: 35px solid #00b900;

              &::before {
                border-right: 20px solid transparent;
                border-bottom: 35px solid #00b900;
              }

              &::after {
                border-left: 20px solid transparent;
                border-bottom: 35px solid #00b900;
              }
            }

            &--hatena {
              border-bottom: 35px solid #5279e7;

              &::before {
                border-right: 20px solid transparent;
                border-bottom: 35px solid #5279e7;
              }

              &::after {
                border-left: 20px solid transparent;
                border-bottom: 35px solid #5279e7;
              }
            }

            &--pocket {
              border-bottom: 35px solid #ee4056;

              &::before {
                border-right: 20px solid transparent;
                border-bottom: 35px solid #ee4056;
              }

              &::after {
                border-left: 20px solid transparent;
                border-bottom: 35px solid #ee4056;
              }
            }
          }
        }
      }
    }

  }

  //共通
  .renew2_wrapper {
    padding: 20px;
  }

  .hukidashi {
    background: #eef5e8;
    border-radius: 0 10px 10px 10px;
    padding: 10px;
    margin-bottom: 20px;
    color: #0E536D;
  }

  .yagitxt {
    position: relative;
    margin-left: 50px;
    line-height: 1.5;

    &::before {
      position: absolute;
      content: "";
      background-image: url(../../../../public/static/img/digram/icon_yagirob.png);
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      width: 40px;
      height: 40px;
      left: -50px;
      top: 0;
    }
  }

  .bluetxt {
    font-weight: bold;
    font-size: 20px;
    color: #0E536D;
  }

  .typeh4 {
    display: inline-block;
  }

  .usertxt-right {
    text-align: right;
  }

  .usertxt {
    display: inline-block;
    background: #ffffff;
    border: 1px solid #0E536D;
    border-radius: 10px 0 10px 10px;
    color: #0E536D;
    font-weight: bold;
  }

  .typeimg {
    display: block;
    margin-bottom: 20px;
  }

  .cv-block {
    text-align: center;

    &__btn {
      position: relative;
      display: block;
      background: #0E536D;
      border: 1px solid #0E536D;
      border-radius: 50px;
      font-weight: bold;
      font-size: 18px;
      color: #ffffff;
      padding: 14px 0;

      &:first-child {
        margin-bottom: 15px;
      }

      &::after {
        content: "";
        width: 13px;
        height: 13px;
        border: 0;
        border-top: 2px solid #fff;
        border-right: 2px solid #fff;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
        position: absolute;
        top: 0;
        right: 20px;
        bottom: 0;
        margin: auto;
      }

      &:hover {
        background: #ffffff;
        border: 1px solid #0E536D;
        color: #0E536D;

        &::after {
          border-top: 2px solid #0E536D;
          border-right: 2px solid #0E536D;
        }
      }

      &--list {
        background: #ffffff;
        color: #0E536D;

        &::after {
          border-top: 2px solid #0E536D;
          border-right: 2px solid #0E536D;
        }

        &:hover {
          background: #0E536D;
          border: 1px solid #ffffff;
          color: #ffffff;

          &::after {
            border-top: 2px solid #ffffff;
            border-right: 2px solid #ffffff;
          }
        }
      }
    }
  }
}
</style>

<script>
export default {
  name: 'YagiDigramResult',
  data () {
    return {
      fullscreenLoading: false,
      digramResult: null,
      result: null
    }
  },
  mounted () {
    this.fullscreenLoading = true
    this.getDigramResult()
  },
  computed: {
    URL () {
      return window.location.href
    }
  },
  methods: {
    async getDigramResult () {
      // クエリパラメータからuuidを取得
      let randomId = this.$route.query.examresult
      // もしクエリパラメータがない場合は、ログインしているユーザーのuuidを取得
      let uuid = ''
      if (!randomId) {
        await new Promise(resolve => setTimeout(resolve, 1000))
        uuid = this.$firebase.user.uid
      }
      // 取得したuuidをもとに診断結果を取得
      const formData = new FormData()
      formData.append('uuid', uuid)
      formData.append('random_id', randomId)
      const app = this
      this.$axios.post(this.$varuna.endPoints.getDigramResult, formData)
        .then(res => {
          app.fullscreenLoading = false
          app.digramResult = res.data.detail_value
          app.result = res.data.result_9
        })
    }
  }
}
</script>
